import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import makeStyles from '@mui/styles/makeStyles';
import { Grid, Typography } from '@mui/material';

export var useStyles = makeStyles(function () {
  return {
    title: {
      fontFamily: 'inherit'
    }
  };
});

var Title = function Title(_ref) {
  var icon = _ref.icon,
      label = _ref.label;

  var classes = useStyles();

  return React.createElement(
    Grid,
    { container: true },
    !R.isNil(icon) && icon,
    React.createElement(
      Typography,
      { variant: 'h6', className: classes.title, inline: 'true' },
      label
    )
  );
};

Title.propTypes = process.env.NODE_ENV !== "production" ? {
  label: PropTypes.string,
  icon: PropTypes.node
} : {};

export default Title;